// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__P2hJp"};